import React, { Component, createRef } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { ReactComponent as IcoCerrar } from "../../res/iconos/cerrar.svg";
import textosJSON from "./textosHome.json";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class Home extends Component {
  state = { hash: null };
  dialogRef = createRef();

  scrollToHash() {
    const urlHash = window.location.hash;
    if (urlHash.length) {
      if (urlHash != this.state.hash) {
        const element = document.getElementById(urlHash.substring(1));
        if (element) {
          element.scrollIntoView();
        }
        this.setState({hash: urlHash});
      }
    }
  }

  componentDidMount() {
    this.dialogRef?.current?.showModal();
    this.scrollToHash()
  }

  componentDidUpdate(prevProps) {
    this.scrollToHash()
  }

  render() {
    const mobile = window.innerWidth < 950;

    const idioma = this.props.location.pathname.split("/")[1]
    const texto = (nombre) => {
      return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
    }

    return (
      <React.Fragment>
      {/*<dialog id="dialog" ref={this.dialogRef} onClick={() => this.dialogRef?.current?.close()}>
        <div style={{ position: "absolute", width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
          <IcoCerrar
              width={(44)}
              height={(44)}
              style={{
                position: "relative",
                marginRight: 5,
                marginTop: 5,
                border: "2px solid",
                borderRadius: (22),
              }}
          />
        </div>
        <img width="100%" height="100%"src={require("../../res/banners/atencion_temporal.jpg")} alt="Atención temporal" />
      </dialog>*/}
      {/*SECCION 1 - Titulo*/}
      <div style={{
        paddingTop: mobile?"20vw":335,
        paddingBottom: 50,
        paddingLeft: "10%",
        paddingRight: "10%",
        backgroundColor: "transparent",
        maxWidth: "100%"
      }}>
        <h1><div className="home_s1_1">{texto("s1_1")}</div><div className="home_s1_2">{texto("s1_2")}</div></h1>
        <Link to={"/" + idioma + "/home#video"}>
          <h3 className="home_s1_boton">+ info</h3>
        </Link>
      </div>

      {/*SECCION 2 - Descripción*/}
      <div style={{
        paddingTop: 94.5,
        paddingBottom: 165,
        paddingLeft: "10%",
        paddingRight: "10%",
        backgroundColor: "#ffffff",
        maxWidth: "100%"
      }}
      id="aboutUs">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 48,
            alignContent: "bottom",
            alignItems: "end",
            justifyContent: "space-around",
            justifyItems: "center"
          }}
        >
          <div style={{flex: 420, minWidth: 300}}>
            <h2 className="home_s2_1">{texto("s2_1")}</h2>
            <p className="home_s2_2">{texto("s2_2")}</p>
          </div>
          <div style={{
            flex: 1029,
            minWidth: mobile?undefined:1000,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            rowGap: 0,
            alignContent: "bottom",
            alignItems: "end",
            justifyContent: "space-between",
            justifyItems: "center"
          }}>
            <div 
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <img
                src={require("../../res/banners/home_s2_logo.png")}
                className="home_s2_logo"
                style={{
                  position: "relative",
                  top: 0,
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  width: 141.25,
                  height: "auto",
                  margin: "auto",
                  zIndex: 1,
                }}
              />
              <img
                src={require("../../res/banners/home_s2_1.png")}
                className="home_s2_1"
                style={{
                  position: "relative",
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  minWidth: 310,
                  maxWidth: "100%",
                  height: "auto",
                  margin: "auto",
                  marginTop: -70.5,
                  zIndex: 0,
                }}
              />
            </div>
            <div 
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <img
                src={require("../../res/banners/home_s2_2.png")}
                className="home_s2_2"
                style={{
                  position: "relative",
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  minWidth: 310,
                  maxWidth: "100%",
                  height: "auto",
                  margin: "auto",
                  marginBottom: -70.5,
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/banners/home_s2_logo.png")}
                className="home_s2_logo"
                style={{
                  position: "relative",
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  width: 141.25,
                  height: "auto",
                  margin: "auto",
                  marginBottom: -70.5,
                  zIndex: 1,
                }}
              />
            </div>
            <div 
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <img
                src={require("../../res/banners/home_s2_logo.png")}
                className="home_s2_logo"
                style={{
                  position: "relative",
                  top: 0,
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  width: 141.25,
                  height: "auto",
                  margin: "auto",
                  marginTop: -70.5,
                  zIndex: 1,
                }}
              />
              <img
                src={require("../../res/banners/home_s2_3.png")}
                className="home_s2_3"
                style={{
                  position: "relative",
                  flexGrow: 0, 
                  flex: 1,
                  objectFit: "fit",
                  objectPosition: "center",
                  minWidth: 310,
                  maxWidth: "100%",
                  height: "auto",
                  margin: "auto",
                  marginTop: -70.5,
                  zIndex: 0,
                }}
              />
            </div>
          </div>
          
        </div>
      </div>

      {/*SECCION 3 - Estadísticas*/}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 100,
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%"
        }}
      >
        <div 
          style={{
            flex: 734,
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            gap: 44,
          }}
        >
          <div className="home_s3_1_1">
            <p className="home_s3_1_1_1">+200.000</p>
            <div style={{width: "100%", maxWidth: 216, display: "flex", flexDirection: "column"}}>
                <div style={{width: "fit-content", justifySelf: "left", alignSelf: "end"}}>
                  <p className="home_s3_1_1_2">{texto("s3_1_1")}</p>
                  <div className="home_s3_1_1_bar1"/>
                </div>
                <div className="home_s3_1_1_bar2"/>
              </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 41,
            }}
          >
            <div className="home_s3_1_2">
              <p className="home_s3_1_2_1">+200</p>
              <div style={{width: "100%", maxWidth: 216, display: "flex", flexDirection: "column"}}>
                <div style={{width: "fit-content", justifySelf: "left", alignSelf: "end"}}>
                  <p className="home_s3_1_2_2">{texto("s3_1_2")}</p>
                  <div className="home_s3_1_2_bar1"/>
                </div>
                <div className="home_s3_1_2_bar2"/>
              </div>
            </div>
            <div className="home_s3_1_3">
              <p className="home_s3_1_2_1">+28.000</p>
              <div style={{width: "100%", maxWidth: 216, display: "flex", flexDirection: "column"}}>
                <div style={{width: "fit-content", justifySelf: "left", alignSelf: "end"}}>
                  <p className="home_s3_1_2_2">{texto("s3_1_3")}</p>
                  <div className="home_s3_1_2_bar1"/>
                </div>
                <div className="home_s3_1_2_bar2"/>
              </div>
            </div>
          </div>
        </div>
        <div 
          style={{
            flex: 749,
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            minWidth: mobile?undefined:600,
            justifyContent: "space-between"
          }}
        >
          <h1 className="home_s3_2_1">{texto("s3_2_1")}</h1>
          <p  className="home_s3_2_2">{texto("s3_2_2")}</p>
          <p  className="home_s3_2_3">{texto("s3_2_3")}</p>
        </div>
      </div>

      {/*SECCION 4 - Video*/}
      <div 
        style={{
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%",
          paddingTop: mobile?48:96,
          paddingBottom: mobile?90:130,
        }}
      >
        <div style={{flex: 48, height: "100%", aspectRatio: 16/9}}>
          <div style={{position: "relative", width: "100%", height: "100%"}} id="video">
            <iframe style={{position: "absolute", width: "100%", height: "100%", left: 0, top: 0}} width="560" height="315" frameborder="0" src="https://www.youtube.com/embed/KmpBFzl9PoI?si=U2aD35lOcc-nrIvB" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>

      {/*SECCION 5 - Internacional*/}
      <div 
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          rowGap: 48,
          columnGap: 72,
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%",
          paddingBottom: mobile?90:175,
        }}
        id="international"
      >
        <div
          style={{
            flex: 975,
            minWidth: 300,
          }}
        >
          <img
            src={require("../../res/banners/home_mapa.png")}
            className="home_s2_mapa"
            style={{
              position: "relative",
              top: 0,
              flexGrow: 0, 
              flex: 1,
              objectFit: "fit",
              objectPosition: "center",
              width: "100%",
              height: "auto",
              margin: "auto",
              zIndex: 1,
            }}
          />
        </div>
        <div
          style={{
            flex: 477,
            minWidth: 300,
            display: "flex",
            flexDirection: "column",
            gap: 12,
            justifyContent: "center",
            justifyItems: "space-between",
          }}
        >
          <h1 className="home_s5_1">{texto("s5_1")}</h1>
          <p className="home_s5_2">{texto("s5_2")}</p>
          <p className="home_s5_3">{texto("s5_3")}</p>
        </div>
      </div>

      {/*SECCION 6 - Nuestras marcas*/}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%",
          paddingBottom: mobile?40:79,
        }}
        id="brands"
      >
        <h1 className="home_s6_1">{texto("s6_1")}</h1>
        <p className="home_s6_2">{texto("s6_2")}</p>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            flexWrap: "wrap",
            columnGap: 30,
            rowGap: 50,
            justifyContent: "center",
            justifyItems: "space-between",
            alignItems: "end",
            alignContent: "center",
          }}
        >
          <a
            style={{
              flex: 1,
              minWidth: 300,
              maxWidth: "30%",
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: 20
            }}
            href="https://coppens.com.ar"
          >
            <img
              src={require("../../res/banners/coppens.png")}
              className="home_s6_coppens"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
            <img
              src={require("../../res/banners/logo_coppens.png")}
              className="home_s6_coppens"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
          </a>
          <a
            style={{
              flex: 1,
              minWidth: 300,
              maxWidth: "30%",
              display: "flex",
              flexDirection: "column",
              gap: 20
            }}
            href="https://emege.com.ar"
          >
            <img
              src={require("../../res/banners/emege.png")}
              className="home_s6_emege"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
            <img
              src={require("../../res/banners/logo_emege.png")}
              className="home_s6_emege"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
          </a>
          <a
            style={{
              flex: 1,
              minWidth: 300,
              maxWidth: "30%",
              display: "flex",
              flexDirection: "column",
              gap: 20
            }}
            href="https://uniqo.com.ar"
          >
            <img
              src={require("../../res/banners/uniqo.png")}
              className="home_s6_uniqo"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
            <img
              src={require("../../res/banners/logo_uniqo.png")}
              className="home_s6_uniqo"
              style={{
                position: "relative",
                top: 0,
                flexGrow: 0, 
                flex: 1,
                objectFit: "fit",
                objectPosition: "center",
                maxWidth: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 1,
              }}
            />
          </a>
        </div>
      </div>

      {/*SECCION 7 - Socios*/}
      <img
        src={require("../../res/banners/camion.png")}
        className="home_s7_camion"
        style={{
          position: "relative",
          objectFit: "cover",
          objectPosition: "center",
          width: "100%",
          height: "auto",
          margin: "auto",
          zIndex: 0,
        }}
        id="partners"
      />
      <div style={{display: "flex", justifyContent: "right", position: "relative", width: "100%", height: "12vw", marginTop: "-6vw"}}>
        <img
          src={require("../../res/banners/home_s2_logo.png")}
          className="home_s7_logo"
          style={{
            position: "relative",
            objectFit: "cover",
            objectPosition: "center",
            width: "12vw",
            height: "auto",
            textAlign: "right",
            marginRight: "4vw",
            zIndex: 0,
          }}
        />
      </div>
      
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%",
          marginTop: "-6vw",
          paddingTop: mobile?"6vw":"3vw",
        }}
      >
        <div
          style={{
            width: "100%"
          }}  
        >
          <h1 className="home_s7_1">{texto("s7_1")}</h1>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            columnGap: 70,
            rowGap: 35,
            justifyContent: "center",
            justifyItems: "space-between",
            alignContent: "stretch",
            alignItems: "stretch"
          }}
        >
          <div
            style={{
              flex: 550,
              minWidth: 300,
              display: "flex",
              flexDirection: "column",
              gap: 17,
              justifyContent: "space-between"
            }}
          >
            <p className="home_s7_2_1">{texto("s7_2_1")}<span className="home_s7_2_2">{texto("s7_2_2")}</span>{texto("s7_2_3")}</p>
            <Link to={"/" + idioma + "/contact"}>
              <h3 className="home_s1_boton">+ info</h3>
            </Link>
          </div>
          <div
            style={{
              flex: 957,
              display: "flex",
              flexDirection: "column",
              gap: 30,
              justifyContent: "space-between" 
            }}
          >
            <p className="home_s7_3">{texto("s7_3")}</p>
            <div 
              style={{
                display: "flex", 
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 10,
                alignContent: "baseline",
                justifyContent: "center",
                justifyItems: "space-between"
              }}
            >
              <img
                src={require("../../res/empresas/1.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "5vw",
                  minWidth: 85,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/empresas/2.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "6vw",
                  minWidth: 100,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/empresas/3.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "6vw",
                  minWidth: 100,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/empresas/4.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "8vw",
                  minWidth: 125,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/empresas/5.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "8vw",
                  minWidth: 125,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
              <img
                src={require("../../res/empresas/6.png")}
                className="home_s7_empresa"
                style={{
                  position: "relative",
                  objectFit: "cover",
                  objectPosition: "center",
                  width: "8vw",
                  minWidth: 125,
                  height: "auto",
                  margin: "auto",
                  zIndex: 0,
                }}
              />
            </div>
          </div>
        </div>
        <div 
          style={{
            marginTop: 40,
            marginBottom: 40,
            width: "100%",
            height: 1,
            backgroundColor: "#c7c7c7"
          }}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 30,
            justifyContent: "space-between" 
          }}
        >
          <p className="home_s7_4">{texto("s7_4")}</p>
          <div 
            style={{
              display: "flex", 
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              alignContent: "baseline",
              justifyContent: "space-between",
              justifyItems: "space-between"
            }}
          >
            <img
              src={require("../../res/clientes/1.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "6vw",
                minWidth: 98,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/2.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "7vw",
                minWidth: 114,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/3.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "9vw",
                minWidth: 139,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/4.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "10vw",
                minWidth: 163,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/5.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "8vw",
                minWidth: 152,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/6.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "7vw",
                minWidth: 120,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/clientes/7.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "8vw",
                minWidth: 133,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
          </div>
        </div>
        <div 
          style={{
            marginTop: 40,
            marginBottom: 40,
            width: "100%",
            height: 1,
            backgroundColor: "#c7c7c7"
          }}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 30,
            justifyContent: "space-between" 
          }}
        >
          <p className="home_s7_5">{texto("s7_5")}</p>
          <div 
            style={{
              display: "flex", 
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              alignContent: "baseline",
              justifyContent: "space-between",
              justifyItems: "space-between"
            }}
          >
            <img
              src={require("../../res/proveedores/1.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "8vw",
                minWidth: 135,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/2.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "6vw",
                minWidth: 97,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/3.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "6vw",
                minWidth: 97,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/4.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "7vw",
                minWidth: 113,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/5.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "5vw",
                minWidth: 89,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/6.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "7vw",
                minWidth: 119,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/7.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "4vw",
                minWidth: 68,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/8.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "6vw",
                minWidth: 102,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <img
              src={require("../../res/proveedores/9.png")}
              className="home_s7_empresa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "8vw",
                minWidth: 123,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
          </div>
        </div>
        <div 
          style={{
            marginTop: 40,
            marginBottom: mobile?50:110,
            width: "100%",
            height: 1,
            backgroundColor: "#c7c7c7"
          }}
        />
      </div>

      {/*SECCION 8 - Posventa*/}
      <div
        style={{
          display: "flex",
          columnGap: 161,
          rowGap: 20,
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "space-between",
          justifyItems: "center",
          flexWrap: "wrap-reverse",
          paddingLeft: "10%",
          paddingRight: "10%",
          backgroundColor: "#ffffff",
          maxWidth: "100%",
          paddingBottom: mobile?85:203
        }}
      >
        <div 
          style={{
            flex: 886,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
            minWidth: "30vw",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div className="home_s8_1_container">
              <h1 className="home_s8_1">{texto("s8_1")}</h1>
              <div className="home_s8_1_bar1" />
              <div className="home_s8_1_bar2"/>
            </div>
            <p className="home_s8_2">{texto("s8_2")}</p>
            <Link to={"/" + idioma + "/contact"}>
              <h3 className="home_s8_boton">+ info</h3>
            </Link>
          </div>
          
          <p className="home_s8_3_1">{texto("s8_3_1")}<span className="home_s8_3_2">{texto("s8_3_2")}</span>{texto("s8_3_3")}</p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              columnGap: 35,
              rowGap: 20,
              paddingLeft: "31px",
              paddingRight: "72px"
            }}
          >
            <img 
              src={require("../../res/banners/zilmet.png")}
              className="home_s8_zilmet"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                flex: 227,
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
            <p className="home_s8_4">{texto("s8_4")}</p>
          </div>
        </div>
        <div
          style={{
            flex: 489,
            minWidth: "min(80vw,480px)",
          }}
        >
          <img 
              src={require("../../res/banners/mapa.png")}
              className="home_s8_mapa"
              style={{
                position: "relative",
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
                height: "auto",
                margin: "auto",
                zIndex: 0,
              }}
            />
        </div>
      </div>

      </React.Fragment>
    );
  }
}

export default withRouterAndNavigate(Home);
